<form [formGroup]="form" class="plan-type-step">
  <app-tile-group
    [control]="form.controls.planType"
    [options]="planTypeOptions"
    [label]="planTypeLabel"
    [required]="true"
    [errorText]="'SERVICE_PLAN.VALIDATION.PLAN_TYPE_REQUIRED' | translate"
  />

  <app-pill-choice
    *ngIf="showHasNdis"
    [control]="form.controls.hasNdis"
    [label]="hasNdisLabel"
    [required]="true"
    [errorText]="'SERVICE_PLAN.VALIDATION.HAS_NDIS_REQUIRED' | translate"
  />
</form>
